import React, { Component } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { CommonLoader } from "../../../common/CommonLoader";
import { formatAmount } from "../../../../services/utils";

class PaperStatsChartLineType extends Component {

  getCurrentYearMonth() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    return `${year}-${month}`;
  }

  formatData = () => {
    const { data, year, frequency, activeTab } = this.props;

    const NbrInscrit = [];
    const Ca = [];

    if (frequency === "MONTHLY") {
      Object.entries(data).forEach(([monthKey, silots]) => {
        let individuelNbrTotal = 0;
        let fiduciaireNbrTotal = 0;
        let individuelCaTotal = 0;
        let fiduciaireCaTotal = 0;

        Object.values(silots).forEach(silot => {
          individuelNbrTotal += silot.individuelNbrInscrit || 0;
          fiduciaireNbrTotal += silot.fiduciareNbrInscrit || 0;
          individuelCaTotal += silot.individuelCa || 0;
          fiduciaireCaTotal += silot.fiduciareCa || 0;
        });

        const [year, month] = monthKey.split("-");
        const formattedMonth = `${month}/${year}`;

        NbrInscrit.push({
          name: formattedMonth,
          Individuel: individuelNbrTotal,
          Fiduciaire: fiduciaireNbrTotal,
          Total: individuelNbrTotal + fiduciaireNbrTotal
        });

        Ca.push({
          name: formattedMonth,
          Individuel: individuelCaTotal / 100,
          Fiduciaire: fiduciaireCaTotal / 100,
          Total: (individuelCaTotal + fiduciaireCaTotal) / 100
        });
      });
    }

    if (frequency === "DAILY") {
      Object.entries(data).forEach(([dayKey, silots]) => {
        let individuelNbrTotal = 0;
        let fiduciaireNbrTotal = 0;
        let individuelCaTotal = 0;
        let fiduciaireCaTotal = 0;

        Object.values(silots).forEach(silot => {
          individuelNbrTotal += silot.individuelNbrInscrit || 0;
          fiduciaireNbrTotal += silot.fiduciareNbrInscrit || 0;
          individuelCaTotal += silot.individuelCa || 0;
          fiduciaireCaTotal += silot.fiduciareCa || 0;
        });

        const [year, month, day] = dayKey.split("-");
        const formattedDay = `${day}/${month}`;

        NbrInscrit.push({
          name: formattedDay,
          Individuel: individuelNbrTotal,
          Fiduciaire: fiduciaireNbrTotal,
          Total: individuelNbrTotal + fiduciaireNbrTotal
        });

        Ca.push({
          name: formattedDay,
          Individuel: individuelCaTotal / 100,
          Fiduciaire: fiduciaireCaTotal / 100,
          Total: (individuelCaTotal + fiduciaireCaTotal) / 100
        });
      });
    }

    if (frequency === "YEARLY") {
      Object.entries(data).forEach(([yearKey, silots]) => {
        let individuelNbrTotal = 0;
        let fiduciaireNbrTotal = 0;
        let individuelCaTotal = 0;
        let fiduciaireCaTotal = 0;

        Object.values(silots).forEach(silot => {
          individuelNbrTotal += silot.individuelNbrInscrit || 0;
          fiduciaireNbrTotal += silot.fiduciareNbrInscrit || 0;
          individuelCaTotal += silot.individuelCa || 0;
          fiduciaireCaTotal += silot.fiduciareCa || 0;
        });

        const year = yearKey;

        NbrInscrit.push({
          name: year,
          Individuel: individuelNbrTotal,
          Fiduciaire: fiduciaireNbrTotal,
          Total: individuelNbrTotal + fiduciaireNbrTotal
        });

        Ca.push({
          name: year,
          Individuel: individuelCaTotal / 100,
          Fiduciaire: fiduciaireCaTotal / 100,
          Total: (individuelCaTotal + fiduciaireCaTotal) / 100
        });
      });
    }

    return activeTab === "chiffreAffaire" ? Ca : NbrInscrit;

  };

  render() {
    const { visibleKeys } = this.props;
    const chartData = this.formatData();

    console.log('=== chartData ===', chartData);


    return (
      <React.Fragment>
        {this.props.fetching ? <div style={{ width: '100%' }}><CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /></div> : (
          <ResponsiveContainer width={'100%'} height={300}>
            <LineChart
              data={chartData}
              margin={{
                top: 10,
                right: 30,
              }}
              style={{
                fontSize: '12px',
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400
              }}
            >
              <CartesianGrid stroke="#D8DDE2" vertical={false} strokeDasharray="4" />
              <XAxis dataKey="name" tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} />
              <YAxis tickMargin={10} axisLine={false} tickLine={false} tick={{ fill: '#6D7F92' }} allowDecimals={false} />
              <Tooltip
                contentStyle={{ 'borderRadius': '5px' }}
                itemStyle={{ textTransform: "capitalize" }}
                formatter={this.props.activeTab === 'chiffreAffaire' ? (value) => formatAmount(value, false) : (value) => value}
              />
              {
                visibleKeys.includes('individuel') &&
                <Line
                  dataKey="Individuel"
                  stroke="#007bff"
                  activeDot={{ r: 8 }}
                  type='linear'
                  dot={{ stroke: '#007bff', strokeWidth: 6 }}
                />
              }
              {
                visibleKeys.includes('fiduciare') &&
                <Line
                  dataKey="Fiduciaire"
                  stroke="#ff7300"
                  activeDot={{ r: 8 }}
                  type='linear'
                  dot={{ stroke: '#ff7300', strokeWidth: 6 }}
                />
              }
              <Line
                dataKey="Total"
                stroke="#000"
                activeDot={{ r: 8 }}
                type='linear'
                dot={{ stroke: '#000', strokeWidth: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </React.Fragment>
    );
  }
}

export default PaperStatsChartLineType;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperStatsChartLineType.js